import React from "react";
import Multimedia from "@sharedComponents/multimedia";

import NoImage from "@assets/images/no-image.svg";

const StorePreviewImage = ({
  topBanner,
  productsThumbImage,
  noBlur = false,
  priority = false,
  className = "",
  fallbackImgClassName = "",
  imgClassName = "",
}) => {
  return (
    <div className={className}>
      <Multimedia
        type="image"
        priority={priority}
        noBlur={noBlur}
        src={topBanner || NoImage}
        width={1200}
        height={380}
        className={fallbackImgClassName}
      />
      <Multimedia
        type="image"
        priority={priority}
        noBlur={noBlur}
        src={productsThumbImage || NoImage}
        width={1200}
        height={580}
        className={imgClassName}
      />
    </div>
  );
};

export default StorePreviewImage;
